module.exports = __webpack_public_path__ + "img/body-1.7419ae10.png";